/**
 * VORE — <vore-lp-offer>
 *
 * Liga o seletor de pacote (1 pack / leve 3 pague 2 / leve 6 pague 4) e o
 * toggle "Compra unica" vs "Assine e economize" ao formulario de add to cart:
 * troca `id` (variante), `selling_plan` (assinatura) e o rotulo do botao.
 *
 * Reproduz o bloco de oferta das paginas Replo (lp / lp2 / lp3 / nad).
 * O envio em si continua sendo do <vore-add-to-cart> (assets/vore-cart.js), que
 * faz POST /cart/add.js e abre o drawer.
 *
 * Sem JS o formulario ja vem com a variante e o preco do tier marcado por
 * padrao no Liquid, entao o bloco continua comprando.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('customElements' in window)) return;
  if (customElements.get('vore-lp-offer')) return;

  class RstLpOffer extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      // O formulario vem de snippets/vore-ajax-add-to-cart: os campos sao os
      // nativos do Shopify (`id`, `selling_plan`) e o rotulo e o [ref="label"].
      this.variantInput =
        this.querySelector('[data-offer-variant-input]') || this.querySelector('input[name="id"]');
      this.planInput =
        this.querySelector('[data-offer-plan-input]') || this.querySelector('input[name="selling_plan"]');
      if (!this.planInput && this.form) {
        this.planInput = document.createElement('input');
        this.planInput.type = 'hidden';
        this.planInput.name = 'selling_plan';
        this.form.appendChild(this.planInput);
      }
      this.priceEl = this.querySelector('[data-offer-price]');
      this.compareEl = this.querySelector('[data-offer-compare]');
      this.buttonLabel =
        this.querySelector('[data-offer-button-label]') || this.querySelector('button [ref="label"]');
      this.buttonTemplate = this.getAttribute('data-button-template') || 'ADICIONAR AO CARRINHO • [price]';
      this.frequency = this.querySelector('[data-offer-frequency]');

      this.tiers = Array.from(this.querySelectorAll('[data-offer-tier]'));
      this.modes = Array.from(this.querySelectorAll('[data-offer-mode]'));

      this.tiers.concat(this.modes).forEach((input) => {
        input.addEventListener('change', () => this.sync());
      });
      if (this.frequency) this.frequency.addEventListener('change', () => this.sync());

      this.sync();
    }

    selectedTier() {
      return this.tiers.find((input) => input.checked) || this.tiers[0];
    }

    subscribeSelected() {
      const mode = this.modes.find((input) => input.checked);
      return !!mode && mode.value === 'subscribe';
    }

    sync() {
      const tier = this.selectedTier();
      if (!tier) return;

      const subscribe = this.subscribeSelected();
      const price = subscribe
        ? tier.getAttribute('data-subscribe-price') || tier.getAttribute('data-price')
        : tier.getAttribute('data-price');
      const compare = tier.getAttribute('data-compare');

      if (this.variantInput) this.variantInput.value = tier.getAttribute('data-variant-id') || '';
      if (this.planInput) {
        this.planInput.value = subscribe && this.frequency ? this.frequency.value || '' : '';
      }
      if (this.priceEl && price) this.priceEl.textContent = price;
      if (this.compareEl) {
        this.compareEl.textContent = compare || '';
        this.compareEl.hidden = !compare;
      }
      if (this.buttonLabel && price) {
        this.buttonLabel.textContent = this.buttonTemplate.replace('[price]', price);
      }

      this.querySelectorAll('[data-offer-plan-panel]').forEach((panel) => {
        panel.hidden = !subscribe;
      });
    }
  }

  customElements.define('vore-lp-offer', RstLpOffer);
})();
